import { Typography } from "@hellocarbo/lasagne";
import { cn } from "@hellocarbo/lasagne/utils";
import { Ref, useImperativeHandle, useState } from "react";
import { useTranslation } from "react-i18next";

import { TScenarioProjections, TTrajectoryScenario } from "@/types";

import { SCENARIO_COLORS } from "./ScenarioProjectionsChart";

export type ScenarioProjectionsChartLegendRef = {
  highlight: (scenario: TTrajectoryScenario | undefined) => void;
};

type ScenarioProjectionsChartLegendProps = {
  scenarioProjections: TScenarioProjections;
  onHover: (scenario: TTrajectoryScenario | undefined) => void;
  ref?: Ref<ScenarioProjectionsChartLegendRef>;
};

function ScenarioProjectionsChartLegend({
  scenarioProjections,
  onHover,
  ref,
}: ScenarioProjectionsChartLegendProps) {
  const { t } = useTranslation("trajectory");
  const [highlightedScenario, setHighlightedScenario] =
    useState<TTrajectoryScenario>();

  useImperativeHandle(ref, () => {
    return {
      highlight(scenario: TTrajectoryScenario | undefined) {
        setHighlightedScenario(scenario);
      },
    };
  }, []);

  const scenarios = Object.keys(
    scenarioProjections
  ) as Array<TTrajectoryScenario>;

  return (
    <ul className="gap-2xs px-2xl flex items-center justify-between">
      {scenarios.map((scenario) => {
        const color = SCENARIO_COLORS[scenario];

        return (
          <li
            className="gap-x-2xs p-3xs group flex cursor-default items-center"
            key={scenario}
            onMouseEnter={() => onHover(scenario)}
            onMouseLeave={() => onHover(undefined)}
          >
            <span
              className="size-3xs mt-[2px] rounded-full ring-2 ring-offset-1"
              style={
                {
                  backgroundColor: color,
                  "--tw-ring-color": `${color}60`,
                } as React.CSSProperties
              }
            />
            <Typography
              step="-2"
              className={cn(
                "text-grayscale group-hover:text-grayscale-dark",
                highlightedScenario === scenario && "text-grayscale-dark"
              )}
            >
              {t(`trajectory:trajectory.scenarios.${scenario}`)}
            </Typography>
          </li>
        );
      })}
    </ul>
  );
}

export default ScenarioProjectionsChartLegend;
